<script lang="ts">
	import Footer from '$lib/component/footer.svelte';
	import Navbar from '$lib/component/navbar.svelte';
	import { onMount } from 'svelte';
	import flatpickr from 'flatpickr';
	import 'flatpickr/dist/flatpickr.css';

	import type { PageServerData } from './$types';
	import { initSwiper } from '$lib/js/script';
	export let data: PageServerData;

	let navDestination = data?.navDestination;
	let info = data?.info;
	let airport = data?.airport;
	let tourpackage = data?.tourpackage;
	let ticket = data?.ticket;
	let activity = data?.activity;

	let selectedType: string = 'airport-pickup';
	let person: number = 1;
	let selectedFrom = '';
	let selectedTo = '';

	onMount(() => {
		initSwiper();

		toggleGroup();

		flatpickr('#arrival-date', {
			enableTime: false,
			dateFormat: 'Y-m-d',
			disableMobile: true,
			minDate: 'today'
		});
	});

	interface Price {
		price_person: number;
		price: number;
	}

	// Fungsi untuk mendapatkan harga terendah
	function getLowestPrice(price_list: Price[]): number {
		if (!price_list || price_list.length === 0) return 0;

		let lowestPrice = price_list[0].price_person;

		for (let price of price_list) {
			if (price.price_person < lowestPrice) {
				lowestPrice = price.price_person;
			}
		}

		return lowestPrice;
	}

	function getLowestPriceOther(price_list: Price[]): number {
		if (!price_list || price_list.length === 0) return 0;

		let lowestPrice = price_list[0].price;

		for (let price of price_list) {
			if (price.price < lowestPrice) {
				lowestPrice = price.price;
			}
		}

		return lowestPrice;
	}

	// Fungsi untuk format harga dalam IDR
	function priceFormat(price: number | string): string {
		return Number(price).toLocaleString('en-US', { minimumFractionDigits: 0 }).replace(/,/g, '.');
	}

	function toggleGroup() {
		return selectedType === 'airport-pickup';
	}
</script>

<svelte:head>
	<title>Airport Transfer - Only You Bali Tours</title>
	<meta name="title" content="Only You Bali Tours" />
	<meta name="description" content="Homepage Only You Bali Tours" />
	<meta name="keyword" content="Bali Tours, Only You Bali Tours, onlyyoubalitours" />
	<link rel="canonical" href="https://onlyyoubalitours.com/airport-transfer" />
</svelte:head>

<Navbar {navDestination} {info} />

<div
	class="w-100 position-relative"
	style="background-image: linear-gradient(to top, rgba(30,30,30,0.3), rgba(30,30,30,0.3)), url('{`https://admin.magotadigital.com/storage/${info.main_images[0]}`}'); background-size: cover; height: 70vh;"
>
	<div class="position-absolute top-50 start-50 translate-middle w-100">
		<div class="row g-0 text-white text-center justify-content-center">
			<div class="col-md-6 px-3">
				<h2 class="fw-semibold fs-1 text-uppercase mb-2">Airport Transfer</h2>
				<p class="text-center mb-3 fs-5 fw-normal">
					Specialty designed Bali tours, day trips & experiences to help create your ultimate Bali
					vacation
				</p>
			</div>
		</div>
	</div>
</div>

<div class="container-fluid py-md-5 py-4 px-3 px-md-5">
	<div class="row g-0">
		<div class="col-md-12 row g-0">
			<div class="col-md-12">
				<div class="card rounded-4 border-0 shadow">
					<form class="card-body" action="https://booking.onlyyoubalitours.com/book" method="GET" enctype="multipart/form-data">
						<input type="hidden" name="cid" value="test">
						<div class="row g-0 align-items-center">
							<div class="col-md-12 mb-2">
								<div class="form-check form-check-inline">
									<input
										class="form-check-input"
										type="radio"
										name="type"
										id="opt-airport-pickup"
										value="airport-pickup"
										bind:group={selectedType}
									/>
									<label class="form-check-label" for="opt-airport-pickup">Airport Pickup</label>
								</div>
								<div class="form-check form-check-inline">
									<input
										class="form-check-input"
										type="radio"
										name="type"
										id="opt-airport-drop"
										value="airport-drop"
										bind:group={selectedType}
									/>
									<label class="form-check-label" for="opt-airport-drop">Airport Drop Off</label>
								</div>
							</div>
							{#if selectedType === 'airport-pickup'}
								<div class="col-md-6 row g-0" id="group-airport-pickup">
									<div class="col-md-6 pe-md-3 mb-2 mb-md-0">
										<label><small>From</small></label>
										<select name="from" class="form-control" bind:value={selectedFrom}>
											<option selected value="Airport">Airport</option>
										</select>
									</div>
									<div class="col-md-6 pe-md-3 mb-2 mb-md-0">
										<label><small>To</small></label>
										<select name="to" class="form-control" bind:value={selectedTo}>
											<option selected disabled value="">Choose destination</option>
											{#each airport as airport}
												{#if airport.to !== 'Airport'}
													<option value={airport.to}>{airport.to}</option>
												{/if}
											{/each}
										</select>
									</div>
								</div>
							{/if}

							{#if selectedType === 'airport-drop'}
								<div class="col-md-6 row g-0" id="group-airport-drop">
									<div class="col-md-6 pe-md-3 mb-2 mb-md-0">
										<label><small>From</small></label>
										<select name="from" class="form-control" bind:value={selectedFrom}>
											<option selected disabled value="">Choose destination</option>
											{#each airport as airport}
												{#if airport.from !== 'Airport'}
													<option value={airport.from}>{airport.from}</option>
												{/if}
											{/each}
										</select>
									</div>
									<div class="col-md-6 pe-md-3 mb-2 mb-md-0">
										<label><small>To</small></label>
										<select name="to" class="form-control" bind:value={selectedTo}>
											<option selected value="Airport">Airport</option>
										</select>
									</div>
								</div>
							{/if}

							<div class="col-md-3 pe-md-3 mb-2 mb-md-0">
								<label><small>Arrival Date</small></label>
								<input
									required
									type="text"
									class="form-control"
									id="arrival-date"
									placeholder="Select Date"
									name="arrival"
								/>
							</div>

							<div class="col-md-3 mb-2 mb-md-0">
								<label><small>Person</small></label>
								<input
									type="number"
									name="person"
									min="1"
									max="5"
									bind:value={person}
									class="form-control"
								/>
							</div>

							<div class="col-md-12 mt-0 mt-md-3 row g-0 justify-content-between align-items-end">
								<div class="col-md-3 mb-2 mb-md-0">
									<p class="mb-0"><small>Total</small></p>
									<p class="mb-0 fs-3 fw-semibold">
										IDR
										{#each airport as airport}
											{#if airport.from === selectedFrom && airport.to === selectedTo}
												{priceFormat(airport.price)}
												<input type="hidden" name="price" value={airport.price} />
											{/if}
										{/each}
									</p>
								</div>
								<div class="col-md-2 row g-0">
									<button type="submit" class="btn btn-dark rounded-3 w-100">Book Now</button>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</div>

<div class="container-fluid p-0">
	<div class="row g-0 mt-4">
		<div class="col-12 mb-4">
			<p class="text-center fs-1 fw-semibold">Our Packages</p>
			<div class="swiper slider-tour-packages-2">
				<div class="swiper-wrapper">
					{#each tourpackage as tourpackage, index}
						<div class="swiper-slide">
							<div class="card" style="border-radius: 15px;">
								<div class="img-best-packages position-relative">
									<img
										src={`https://admin.magotadigital.com/storage/${tourpackage.featured_images[0]}`}
										class="w-100 h-100 object-fit-cover"
										alt="Image Packages"
									/>
									{#if index < 4}
										<span
											class="badge text-bg-warning fw-medium py-1 px-2 position-absolute top-0 end-0 m-2"
											>Best Seller</span
										>
									{/if}
								</div>
								<div class="card-body pt-2 d-flex flex-column justify-content-between">
									<div class="pb-4">
										<p class="fw-semibold mb-2 text-uppercase lh-sm">
											<a
												data-sveltekit-reload
												href="/package/{tourpackage.slug}"
												class="text-decoration-none text-black">{tourpackage.name}</a
											>
										</p>

										<div class="mb-4">
											<small>
												{#each tourpackage.information as information}
													<span class="badge text-bg-secondary py-1 fw-light me-1 mt-2"
														>{information.name}</span
													>
												{/each}
											</small>
										</div>
									</div>
									<div>
										<div class="d-flex justify-content-between align-items-center">
											<div class="lh-sm">
												<p class="mb-0">
													<span class="fw-semibold"
														>IDR {priceFormat(getLowestPrice(tourpackage.price_list))}</span
													>
												</p>

												<!-- {% if package.discount == 1 %}
                                                        {% set priceDiscount  =  lowestPrice * ((100 - package.discount_percentage)/100)  %}
                                                        {% set discount = ((100 - package.discount)/100) %}
                                                        <p class="mb-0 fw-semibold">Start From</p>
                                                        <p class="mb-0">
                                                            <small>
                                                                <span class="text-decoration-line-through fw-light">IDR {{ package.priceFormat(lowestPrice) }}</span> <span class="badge text-bg-primary align-middle ms-1 fw-normal">{{package.discount_percentage}}%</span> 
                                                            </small>
                                                        </p> 
                                                        <p class="mb-0"><span class="fw-semibold">IDR {{ package.priceFormat(priceDiscount) }}</span></p>
                                                        {% else %}
                                                        <p class="mb-0 fw-semibold">Start From</p> -->
											</div>
											<div class="">
												<a
													data-sveltekit-reload
													href="/package/{tourpackage.slug}"
													class="btn btn-warning rounded-3 fw-medium">Book Now</a
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					{/each}
				</div>
			</div>
		</div>

		<div class="col-12 py-4 bg-light">
			<p class="text-center fs-1 fw-semibold">Our Activities</p>
			<div class="swiper slider-activities-2">
				<div class="swiper-wrapper">
					{#each activity as activity, index}
						<div class="swiper-slide">
							<div class="card" style="border-radius: 15px;">
								<div class="img-best-packages position-relative">
									<img
										src={`https://admin.magotadigital.com/storage/${activity.featured_images[0]}`}
										class="w-100 h-100 object-fit-cover"
										alt="Image Activities"
									/>
									{#if index < 4}
										<span
											class="badge text-bg-warning fw-medium py-1 px-2 position-absolute top-0 end-0 m-2"
											>Best Seller</span
										>
									{/if}
								</div>
								<div class="card-body pt-2 d-flex flex-column justify-content-between">
									<div class="pb-4">
										<p class="fw-semibold mb-2 text-uppercase lh-sm">
											<a
												data-sveltekit-reload
												href="/activities/{activity.slug}"
												class="text-decoration-none text-black">{activity.name}</a
											>
										</p>
										{#if activity.information}
											<div class="mb-4">
												<small>
													{#each activity.information as information}
														<span class="badge text-bg-secondary py-1 fw-light me-1 mt-2"
															>{information.name}</span
														>
													{/each}
												</small>
											</div>
										{/if}
									</div>
									<div>
										<div class="d-flex justify-content-between align-items-center">
											<div class="lh-sm">
												<!-- <p class="mb-0 fw-semibold">Start From</p> -->
												<p class="mb-0">
													<span class="fw-semibold">IDR {priceFormat(getLowestPriceOther(activity.price_list))}</span>
												</p>
											</div>
											<div class="">
												<a
													data-sveltekit-reload
													href="/activities/{activity.slug}"
													class="btn btn-warning rounded-3 fw-medium">Book Now</a
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					{/each}
				</div>
			</div>
		</div>

		<div class="col-12 mb-4">
			<p class="text-center fs-1 fw-semibold">Our Tickets</p>
			<div class="swiper slider-tickets-2">
				<div class="swiper-wrapper">
					{#each ticket as ticket, index}
						<div class="swiper-slide">
							<div class="card" style="border-radius: 15px;">
								<div class="img-best-packages position-relative">
									<img
										src={`https://admin.magotadigital.com/storage/${ticket.featured_images[0]}`}
										class="w-100 h-100 object-fit-cover"
										alt="Image Ticket"
									/>
									{#if index < 4}
										<span
											class="badge text-bg-warning fw-medium py-1 px-2 position-absolute top-0 end-0 m-2"
											>Best Seller</span
										>
									{/if}
								</div>
								<div class="card-body pt-2 d-flex flex-column justify-content-between">
									<div class="pb-4">
										<p class="fw-semibold mb-2 text-uppercase lh-sm">
											<a
												data-sveltekit-reload
												href="/ticket/{ticket.slug}"
												class="text-decoration-none text-black">{ticket.name}</a
											>
										</p>
										{#if ticket.information}
											<div class="mb-4">
												<small>
													{#each ticket.information as information}
														<span class="badge text-bg-secondary py-1 fw-light me-1 mt-2"
															>{information.schedule}</span
														>
													{/each}
												</small>
											</div>
										{/if}
									</div>
									<div>
										<div class="d-flex justify-content-between align-items-center">
											<div class="lh-sm">
												<!-- <p class="mb-0 fw-semibold">Start From</p> -->
												<p class="mb-0">
													<span class="fw-semibold">IDR {priceFormat(getLowestPriceOther(ticket.price_list))}</span>
												</p>
											</div>
											<div class="">
												<a
													data-sveltekit-reload
													href="/ticket/{ticket.slug}"
													class="btn btn-warning rounded-3 fw-medium">Book Now</a
												>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					{/each}
				</div>
			</div>
		</div>
	</div>
</div>

<div
	class="container-fluid py-md-5 py-4 px-md-5 px-3 text-black"
	style="background-color: #efc109;"
>
	<div class="row g-0 justify-content-center">
		<div class="col-md-10 text-center">
			<h2 class="fw-semibold fs-1 text-uppercase">Get in Touch</h2>
			<p class="fs-6 lh-base mb-4">
				Ready to explore your dream destination? If you're interested in discovering more about our
				tour packages, we're here to help! Reach out to us today for personalized recommendations,
				detailed itineraries, and exclusive offers. Let us craft the perfect travel experience for
				you.
			</p>
			<p class="mb-0">
				<a href={info.wa} target="_blank" class="btn btn-dark rounded-3"
					>Contact Now<i class="ri-whatsapp-line fs-5 align-middle ms-2 fw-medium"></i></a
				>
			</p>
		</div>
	</div>
</div>

<Footer {info} />
